import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpcomingTeamsComponent } from './upcoming-teams/upcoming-teams.component';
import { SharedModule } from '../shared/shared.module';
import { UpcomingTeamsBarChartComponent } from './upcoming-teams/upcoming-teams-bar-chart/upcoming-teams-bar-chart.component';
import { RouterModule } from '@angular/router';
import { RecentAcceptsComponent } from './recent-accepts/recent-accepts.component';
import { RecentAcceptsItemComponent } from './recent-accepts/recent-accepts-item/recent-accepts-item.component';
import { RecentFormResponsesComponent } from './recent-form-responses/recent-form-responses.component';
import { HomeWidgetCardComponent } from './home-widget-card/home-widget-card.component';
import { InProgressApplicationsComponent } from './in-progress-applications/in-progress-applications.component';
import { InProgressApplicationsItemComponent } from './in-progress-applications/in-progress-applications-item/in-progress-applications-item.component';
import { LatestFormSubmissionsComponent } from './latest-form-submissions/latest-form-submissions.component';
import { LatestFormSubmissionsItemComponent } from './latest-form-submissions/latest-form-submissions-item/latest-form-submissions-item.component';

@NgModule({
  declarations: [
    UpcomingTeamsComponent,
    UpcomingTeamsBarChartComponent,
    RecentAcceptsComponent,
    RecentAcceptsItemComponent,
    RecentFormResponsesComponent,
    HomeWidgetCardComponent,
    InProgressApplicationsComponent,
    InProgressApplicationsItemComponent,
    LatestFormSubmissionsComponent,
    LatestFormSubmissionsItemComponent
  ],
  imports: [CommonModule, SharedModule, RouterModule],
  exports: [
    UpcomingTeamsComponent,
    RecentAcceptsComponent,
    RecentFormResponsesComponent,
    HomeWidgetCardComponent,
    InProgressApplicationsComponent,
    LatestFormSubmissionsComponent
  ]
})
export class WidgetsModule {}
